// frontend/src/components/ScientificAnalysis/AlertsList.tsx

import React from 'react';

interface Props {
  nullAnalysis: any;
}

const renderValue = (value: any): React.ReactNode => {
  if (value === null || value === undefined) return '—';
  if (Array.isArray(value)) return value.join(', ');
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

export const AlertsList: React.FC<Props> = ({ nullAnalysis }) => {
  if (!nullAnalysis) {
    return null;
  }

  const fields = Object.entries(nullAnalysis);
  const totalNulls = nullAnalysis.total_null_values || 0;

  return (
    <div style={{
      background: 'linear-gradient(135deg, #1a1a2e, #16213e)',
      borderRadius: '12px',
      padding: '20px',
      border: '1px solid #1a4a7a',
      marginBottom: '24px',
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    }}>
      <h3 style={{ color: '#4fc3f7', margin: 0 }}>
        📋 Análise de Dados Faltantes (Nulos)
      </h3>

      {/* CAMADA 1: RESUMO EM LINGUAGEM DE NEGÓCIO */}
      <div style={{
        background: totalNulls > 0 ? 'rgba(255, 193, 7, 0.1)' : 'rgba(102, 187, 106, 0.1)',
        borderLeft: `3px solid ${totalNulls > 0 ? '#ffc107' : '#66bb6a'}`,
        borderRadius: '8px',
        padding: '16px',
        color: '#e0e0e0',
        fontSize: '14px',
        lineHeight: 1.6,
      }}>
        <p style={{ margin: '0 0 8px 0' }}>
          💡 <strong style={{ color: '#4fc3f7' }}>O que isso significa:</strong>
        </p>
        <p style={{ margin: 0 }}>
          {totalNulls > 0 ? (
            <>
              Encontramos <strong>{totalNulls} valores faltantes</strong> no seu dataset. 
              Isso pode acontecer quando um campo não foi preenchido ou não existia na origem.
              É importante tratar esses dados antes de treinar o modelo.
            </>
          ) : (
            <>
              <strong>Ótima notícia!</strong> Não encontramos nenhum valor faltante (nulo) no seu dataset. 
              Isso significa que os dados estão completos e prontos para a análise.
            </>
          )}
        </p>
      </div>

      {/* CAMADA 2: TABELA TÉCNICA */}
      <div style={{ overflowX: 'auto', background: 'rgba(10, 10, 26, 0.4)', borderRadius: '8px', padding: '12px' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px', color: '#ffffff' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #1a4a7a' }}>
              <th style={{ padding: '12px 16px', textAlign: 'left', color: '#8899aa', fontWeight: 600, fontSize: '12px' }}>Campo</th>
              <th style={{ padding: '12px 16px', textAlign: 'left', color: '#8899aa', fontWeight: 600, fontSize: '12px' }}>Valor</th>
            </tr>
          </thead>
          <tbody>
            {fields.map(([key, value]) => (
              <tr key={key} style={{ borderBottom: '1px solid #16213e' }}>
                <td style={{ padding: '12px 16px', color: '#8899aa' }}>{key}</td>
                <td style={{ padding: '12px 16px' }}>{renderValue(value)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};